import type { CloseButtonProps } from '@core/dialogs/common/CloseButton';
import { CloseButton } from '@core/dialogs/common/CloseButton';

import { useDialogContext } from './DialogContextProvider';
import { getCloseCss } from './styles';

export type Props = {
  showCloseAction: boolean;
  onClose?: CloseButtonProps['onClick'];
};

export const Close = (props: Props) => {
  const { showCloseAction, onClose } = props;

  const { invert, color, variant, sticky } = useDialogContext();

  return (
    <div
      css={getCloseCss({ color, variant, sticky: sticky === 'headingGroup' })}
    >
      {showCloseAction && <CloseButton invert={invert} onClick={onClose} />}
    </div>
  );
};
